/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import React, { Component } from 'react';

import PropTypes from 'prop-types';

// COMPONENTS
import CheckBox from '../CheckBox/CheckBox';
import Button from "../Button/Button";

import styles from './CheckoutContainer.module.css';
import { store } from "../../redux/store";
import Loader from "../Loader/Loader";
import {
  getCheckoutPartProps,
  getCheckoutCheckIconSrc,
  getCheckoutAlertIconSrc,
  isReviewOrderBrandRefresh,
} from '../../pages/ReviewOrder/reviewOrderBrandRefreshClasses';

const expandIcon = require('./imgs/expand-icon.svg');
const expandLightIcon = require('./imgs/expand-light-icon.svg');
const brandRefreshExpandIcon = require('./imgs/brand-refresh-expand-icon.svg');
const alertIcon = require('./imgs/alert-icon.svg');

class CheckoutContainer extends Component {
    unsubscribeMounts;

    unsubscribeUpdates;

  constructor(props) {
    super(props);
    // Generate unique ID for this accordion instance
    this.panelId = `checkout-container-panel-${Math.random().toString(36).substr(2, 9)}`;
    this.buttonId = `checkout-container-button-${Math.random().toString(36).substr(2, 9)}`;
    this.state = {
      expanded: props.expanded ?? false,
      isSelected: false
    };
  }

  componentDidMount() {
    this.unsubscribeMounts = store.subscribe(() => {});
  }

  componentDidUpdate() {
    const { expanded } = this.state;

    if (this.unsubscribeUpdates) {
        this.unsubscribeUpdates();
    }

    this.unsubscribeUpdates = store.subscribe(() => {
      if (expanded === true) {
        return 
      }
      this.setState({expanded})
    });
  }

  componentWillUnmount() {
      if (this.unsubscribeMounts) {
          this.unsubscribeMounts();
      }
      if (this.unsubscribeUpdates) {
          this.unsubscribeUpdates();
      }
  }

  /**
   * Toggles isSelected state
   */
  toggleSelected = (e) => {
    const { onChange, onExpand } = this.props;
    const { expanded, isSelected } = this.state;
    const { props } = this;
    const { component, type } = props;

    if (component && expanded === false) {
      if (type === 'payment') {
        component.setState({
          addPayment: false,
          editPayment: false,
          paymentDetails: false,
          addSchoolCash: false
        });
      }
    }

    this.setState({ expanded: !expanded });
    if (onExpand) {
      onExpand(!expanded);
    }
    if (onChange) {
      onChange(!isSelected, e);
    }
  };

  /**
   * Handles data transfer between child to parent
   */
  handleSelection = e => {
    const { onChange } = this.props;
    const { isSelected } = this.state;
    this.setState({ isSelected: !isSelected });
    if (onChange) {
      onChange(!isSelected, e);
    }
  };

  /**
   * Handles correct component interaction
   * based on available props
   */
  handleInteraction = e => {
    const { children, check, navigateTo, forceDisableExpand } = this.props;
    if (forceDisableExpand === false) {
      if (navigateTo) navigateTo();
      if (!children && !check) return;
      if (children) {
        e.preventDefault();
        // eslint-disable-next-line consistent-return
        return this.toggleSelected(e);
      }
      this.handleSelection(e);
    }
  };

  /**
   * Action when the section button is clicked.
   *
   * @param {Function} action
   *
   * @author Elizabeth Clouser <elizabeth@somepage.com>
   */
  btnClick = async (action) => {
    await action();

    this.setState({
      expanded: false
    });
  };

  render() {
    const { expanded } = this.state;
    const { cookieDough } = this.props;
    const { isSelected } = cookieDough ? this.props : this.state;
    const {
      children,
      innerContext,
      header,
      subHeader,
      check,
      loading,
      subHeaderAsset,
      isAlert,
      navigateTo,
      btnDisabled,
      btnStyles,
      btnAction,
      disabled,
      label,
      subHeaderClass,
      className,
      forceDisableExpand,
      expandedHeader,
      keepHeaderVisibleWhenExpanded,
    } = this.props;


      let containerClass = ( children || check || navigateTo ) && !disabled ? styles.containerInteractive : null;

      if(disabled === true){
        containerClass = styles.containerDisabled;
      }
    const doWeNeedDisplayExpander = forceDisableExpand === false && (children || navigateTo);
    
    // Determine if accordion is locked in expanded state (always expanded and not collapsible)
    const isLockedExpanded = expanded && forceDisableExpand === true;
    
    // Build aria-label for the button
    let ariaLabel = header;
    if (subHeader) {
      ariaLabel = `${header} ${subHeader}`;
    }
    if (doWeNeedDisplayExpander && !expanded) {
      ariaLabel = `Change ${ariaLabel}`;
    }

    const isBrandRefresh = isReviewOrderBrandRefresh();
    const expandIconSrc = isBrandRefresh ? brandRefreshExpandIcon : expandIcon;
    const alertIconSrc = getCheckoutAlertIconSrc(alertIcon);
    const showBrandRefreshExpandedHeader = isBrandRefresh && expanded && expandedHeader;
    const triggerHeader = showBrandRefreshExpandedHeader ? expandedHeader : header;

    return (
      <div
        className={`${styles.checkoutContainerWrapper} ${className} ${
          isBrandRefresh
            ? ''
            : 'bg-white dark:bg-dark shadow-md'
        } w-full`}
        data-part={getCheckoutPartProps('checkout-container')}
      >
        <div
          className={`${styles.checkoutContainer} ${expanded ? styles.containerExpanded : null} ${keepHeaderVisibleWhenExpanded ? styles.keepHeaderVisibleWhenExpanded : null}`}
          data-part={getCheckoutPartProps('checkout-container-inner')}
        >
          <h3 className={styles.accordionHeading}>
            <button
              id={this.buttonId}
              type="button"
              onClick={e => this.handleInteraction(e)}
              onKeyDown={e => {
                if (e.key === 'Enter' || e.key === ' ') {
                  this.handleInteraction(e);
                }
              }}
              aria-expanded={doWeNeedDisplayExpander ? expanded : undefined}
              aria-controls={doWeNeedDisplayExpander ? this.panelId : undefined}
              aria-disabled={isLockedExpanded ? true : undefined}
              aria-label={ariaLabel}
              disabled={isLockedExpanded}
              className={[
                styles.checkoutContainerCollapsedContainer,
                containerClass,
              ].join(' ')}
              data-part={getCheckoutPartProps('checkout-container-trigger')}
            >
              {/* COMPONENT CONTAINER LEFT SIDE */}
              <div
                className={styles.checkoutContainerLeft}
                data-part={getCheckoutPartProps('checkout-container-left')}
                data-expanded-header={showBrandRefreshExpandedHeader ? 'true' : undefined}
              >
                <p
                  className='text-dark dark:text-white'
                  data-part={getCheckoutPartProps('checkout-container-header')}
                  data-expanded-title={showBrandRefreshExpandedHeader ? 'true' : undefined}
                >
                  {triggerHeader}
                </p>
                
                {!showBrandRefreshExpandedHeader && (subHeader || subHeaderAsset) ? (
                  <span
                    className={`text-darkElevationPrimary dark:text-white flex item-center gap-1
                    ${subHeaderClass}
                    ${isAlert ? styles.alert : null}`}
                    data-part={getCheckoutPartProps('checkout-container-subheader')}
                  >
                    {subHeaderAsset ? <img alt="" src={subHeaderAsset} /> : null }
                    {subHeader ? <p>{subHeader}</p> : null}
                  </span>
                ) : null}

                {innerContext? (<span className={`${styles.checkoutContainerInnerContext} text-darkElevationPrimary dark:text-white`}>{innerContext}</span>) : null}

              </div>
              {/* COMPONENT CONTAINER RIGHT SIDE */}
              <div
                className={`${styles.checkoutContainerRight} font-montserratMedium text-xs leading-[14px]  text-dark dark:text-white`}
                data-part={getCheckoutPartProps('checkout-container-right')}
              >
                {children && isAlert ? (
                  <img
                    id={styles.alertIcon}
                    alt=""
                    src={alertIconSrc}
                    data-part={getCheckoutPartProps('checkout-alert-icon')}
                  />
                ) : null}
                {doWeNeedDisplayExpander ? (
                  <>
                    {!expanded ? (
                      <span
                        className={styles.changeText}
                        data-part={getCheckoutPartProps('checkout-change')}
                      >
                        CHANGE
                      </span>
                    ) : null}
                    {isBrandRefresh ? (
                      <img
                        className={`${navigateTo ? styles.navigate : null} ${expanded ? styles.expandIconExpanded : ''}`}
                        data-part={getCheckoutPartProps('checkout-expand-icon')}
                        alt=""
                        src={expandIconSrc}
                        aria-hidden="true"
                        width={16}
                        height={10}
                      />
                    ) : (
                      <>
                        <img
                          className={`${navigateTo ? styles.navigate : null} dark:hidden block`}
                          id={`${styles.expandIcon}`}
                          alt=""
                          src={expandIcon}
                          aria-hidden="true"
                        />
                        <img
                          className={`${navigateTo ? styles.navigate : null} dark:block hidden`}
                          id={`${styles.expandIcon}`}
                          alt=""
                          src={expandLightIcon}
                          aria-hidden="true"
                        />
                      </>
                    )}
                  </>
                ) : null}

                {check && loading ? (
                  <Loader height={25} />
                ) : null }

                {check && !loading ? (
                  <CheckBox
                    onClick={this.handleInteraction}
                    isChecked={isSelected}
                    checkIconSrc={getCheckoutCheckIconSrc()}
                  />
                ) : null}
              </div>
            </button>
          </h3>
          {/* COMPONENT BODY */}
          <div 
            id={this.panelId}
            className={styles.containerDropDownChildren}
            role={doWeNeedDisplayExpander ? "region" : undefined}
            aria-labelledby={doWeNeedDisplayExpander ? this.buttonId : undefined}
          >
            {expanded ? children : null}

            {btnAction && expanded ? (
              <Button
                customContainerStyles={btnStyles}
                disabled={btnDisabled}
                handleSubmit={() => this.btnClick(btnAction)}
                label={label}
              />
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

CheckoutContainer.propTypes = {
    children:
    PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.element),
        PropTypes.element
    ]
    ),
    header: PropTypes.string.isRequired,
    subHeader: PropTypes.string,
    innerContext: PropTypes.string,
    check: PropTypes.bool,
    loading: PropTypes.bool,
    onChange: PropTypes.func,
    onExpand: PropTypes.func,
    subHeaderAsset: PropTypes.shape(),
    isAlert: PropTypes.bool,
    navigateTo: PropTypes.func,
    label: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    subHeaderClass: PropTypes.string,
    forceDisableExpand: PropTypes.bool,
    expandedHeader: PropTypes.string,
    keepHeaderVisibleWhenExpanded: PropTypes.bool,
};

CheckoutContainer.defaultProps = {
    children: null,
    innerContext: null,
    check: false,
    loading: false,
    onChange: null,
    onExpand: null,
    subHeaderAsset: null,
    isAlert: false,
    navigateTo: null,
    subHeader: null,
    label: 'Select',
    subHeaderClass: null,
    forceDisableExpand: false,
    expandedHeader: null,
    keepHeaderVisibleWhenExpanded: false,
};

export default CheckoutContainer;
